import { ChevronDown } from 'react-feather'
import ScoreBadge from './ScoreBadge'

const RegionCard = ({ region, isExpanded, onToggle }) => {
  return (
    <div
      className="card border-0 shadow-sm mb-3 region-card"
      style={{
        background: 'linear-gradient(135deg, #006386 0%,#0479a4 100%)',
        color: 'white',
      }}
      data-testid={`findora-dashboard-region-${region.id}`}
    >
      <div className="card-body">
        <div
          className="cursor-pointer"
          onClick={onToggle}
          style={{ cursor: 'pointer' }}
        >
          {/* DESKTOP VIEW */}
          <div className="d-none d-lg-flex align-items-center">
            <div
              className={`chevron-icon me-3 ${isExpanded ? 'expanded' : 'collapsed'}`}
            >
              <ChevronDown size={20} />
            </div>
            <div className="me-4 flex-grow-1">
              <h5 className="mb-1 fw-semibold">{region.name}</h5>
              <div className="d-flex align-items-center gap-3">
                <span className="small opacity-75">
                  {region.suppliers.length} Suppliers
                </span>
                <span className="small opacity-75">
                  {region.suppliers.reduce(
                    (sum, s) => sum + s.members.length,
                    0,
                  )}{' '}
                  Members
                </span>
              </div>
            </div>
            <div className="d-flex align-items-center gap-3 flex-shrink-0">
              <div className="d-flex align-items-center gap-2">
                <span className="small opacity-75">Onboarding</span>
                <ScoreBadge score={region.onboardingScore} size="normal" />
              </div>
              <div className="d-flex align-items-center gap-2">
                <span className="small opacity-75">Wage &amp; Productivity</span>
                <ScoreBadge score={region.wageScore} size="normal" />
              </div>
            </div>
          </div>

          {/* MOBILE VIEW */}
          <div className="d-lg-none">
            <div className="d-flex align-items-center mb-3">
              <div
                className={`chevron-icon me-3 ${isExpanded ? 'expanded' : 'collapsed'}`}
              >
                <ChevronDown size={20} />
              </div>
              <div className="flex-grow-1">
                <h5 className="mb-1 fw-semibold">{region.name}</h5>
                <div className="d-flex align-items-center gap-3">
                  <span className="small opacity-75">
                    {region.suppliers.length} Suppliers
                  </span>
                  <span className="small opacity-75">
                    {region.suppliers.reduce(
                      (sum, s) => sum + s.members.length,
                      0,
                    )}{' '}
                    Members
                  </span>
                </div>
              </div>
            </div>

            {/* SCORES FOR MOBILE VIEW */}
            <div className="row g-2">
              <div className="col-6">
                <div
                  className="d-flex align-items-center justify-content-center p-2 rounded"
                  style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
                >
                  <div className="text-center">
                    <div className="small opacity-75 mb-1">Onboarding</div>
                    <ScoreBadge score={region.onboardingScore} size="normal" />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div
                  className="d-flex align-items-center justify-content-center p-2 rounded"
                  style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
                >
                  <div className="text-center">
                    <div className="small opacity-75 mb-1">W&amp;P</div>
                    <ScoreBadge score={region.wageScore} size="normal" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegionCard
